import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
    getReportData,
    getDivisionsForDropDown,
    getJobsForDropdown,
    getChecklistForDropdown
};

async function getDivisionsForDropDown(id) {
    var divisionArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllDivisionsByEstateID', 'estateID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            divisionArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return divisionArray;
}

async function getJobsForDropdown() {
    var jobArray = [];
    const response = await CommonGet('/api/TappingCheckListReport/GetAllRubberJobTypes', null)
    for (let item of Object.entries(response.data)) {
        jobArray[item[1]["rubberJobTypeID"]] = item[1]["rubberJobTypeName"]
    }
    return jobArray;
}

async function getChecklistForDropdown(model) {
    var checklistArray = [];
    const response = await CommonGet('/api/TappingCheckListReport/GetChecklistsPerday', 'selectedDate=' + model.searchDate + '&jobTypeID=' + model.jobTypeID + '&divisionID=' + model.divisionID)
    for (let item of Object.entries(response.data)) {
        checklistArray[item[1]["referenceNo"]] = item[1]["referenceNo"]
    }
    return checklistArray;
}

async function getReportData(model) {
    const response = await CommonPost('/api/TappingCheckListReport/GetTappingManualCheckListReportDetails', null, model);
    return response.data;
}
